import script from "./OrganizationContractDisciplines.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrganizationContractDisciplines.vue?vue&type=script&setup=true&lang=ts"

import "./OrganizationContractDisciplines.vue?vue&type=style&index=0&id=15b70531&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15b70531"]])

export default __exports__